import { useContext, useEffect, useState } from "react"
import { FormLabel, InlineLoading } from "carbon-components-react"
import "../SpeakerBio/SpeakerBio.scss"
import { getSpeakers } from "api/functions/functions"
import TileWrapper from "ui/TileWrapper/TileWrapper"
import MainContext from "context/MainContext"

const SpeakersList = (props) => {

    const context = useContext(MainContext)
    const [value, setValue] = useState([])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setValue(props.initialValue)
    }, [props.initialValue])

    useEffect(() => {
        if (value && value.length > 0) {
            if (value !== props.initialValue) {
                props.onChange(value)
            }
            if (!data?.length || data?.length !== value.length) {
                loadSpeakerData()
            }
        }
        else {
            setData([])
        }
    }, [value])

    const loadSpeakerData = async () => {
        setLoading(true)
        try {
            const res = await getSpeakers({
                ids: value
            }, true)
            setData(res.data)
        } catch (e) {

        }
        finally {
            setLoading(false)
        }
    }

    const goUp = (position) => {
        move(position, position - 1)
    }
    const goDown = (position) => {
        move(position, position + 1)
    }

    const move = (position, newPosition) => {
        let newCollection = [...value]
        let newData = [...data]
        const removed = newCollection.splice(position, 1)
        newCollection.splice(newPosition, 0, removed[0])
        setValue(newCollection)

        const removedData = newData.splice(position, 1)
        newData.splice(newPosition, 0, removedData[0])
        setData(newData)

        // console.log("loadSpeakerData ---", newCollection)
        // // props.onSort(newCollection.map(item => item.id))
    }

    const content = (
        <>
            {
                loading ? (
                    <InlineLoading />
                ) :
                    data?.length ?
                        data.map((item, index) => {
                            return (
                                <TileWrapper
                                    // avatar={item.avatar ? (
                                    //     <SpeakerBioAvatar src={item.avatar} />
                                    // ) : null}
                                    titleComponent={"div"}
                                    key={`main-list-item-${item.id}-${index}`}
                                    title={`${item.firstname} ${item.lastname}${context.user.is_admin ? ` (${item.id})` : ""}`}
                                    // onTitleClicked={props.onClick}
                                    enableGoUp={index > 0}
                                    disableTitlePadding={true}
                                    enableGoDown={index < data.length - 1}
                                    goUp={() => goUp(index)}
                                    goDown={() => goDown(index)}

                                />
                            )
                        }) : (
                            <div>
                                Empty
                            </div>
                        )
            }
        </>
    )

    return (
        <div className="speaker-bio">
            {
                props.labelText ? (
                    <div>
                        <FormLabel>
                            {props.labelText}
                        </FormLabel>
                    </div>
                ) : null
            }

            {content}
        </div>

    )
}

export default SpeakersList